import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import {
  HttpService,
  TranslateService,
  UserProfileService,
  VersionCheckService,
} from '__services';
import { Subject } from 'rxjs';
import { GoogleMapsLoaderService } from './core/services/google-maps-loader.service';
import { Router } from '@angular/router';
import { environment } from '~/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public destroy$: Subject<any> = new Subject();

  constructor(
    public loader: LoadingBarService,
    private versionCheckService: VersionCheckService,
    private translateService: TranslateService,
    private mapsLoader: GoogleMapsLoaderService,
    private router: Router,
    private http: HttpService,
    private userProfileService: UserProfileService,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.mapsLoader.load();

    await this.translateService.init();

    if (location.hostname !== 'localhost') {
      this.versionCheckService.initVersionCheck(
        `${window.location.origin}/version.json`,
        1000 * 60,
      );
    }

    // await this.handleMicrosoftRedirect();
  }

  // async handleMicrosoftRedirect(): Promise<void> {
  //   const alreadyLoggedIn = localStorage.getItem('access_token');
  //   if (alreadyLoggedIn) return;

  //   const urlParams = new URLSearchParams(window.location.search);
  //   const code = urlParams.get('code');
  //   if (!code) return;

  //   const oauth = environment.AWS_CONFIG.Auth.Cognito.loginWith.oauth;
  //   const domain = oauth.domain;
  //   const clientId = oauth.userPoolClientIdMS;
  //   const redirectUri = oauth.redirectSignIn[0];

  //   window.history.replaceState({}, document.title, '/');

  //   const ref = this.loader.useRef('ms-login');
  //   ref.start();

  //   try {
  //     const body = new URLSearchParams();
  //     body.set('grant_type', 'authorization_code');
  //     body.set('client_id', clientId);
  //     body.set('code', code);
  //     body.set('redirect_uri', redirectUri);

  //     const res = await fetch(`https://${domain}/oauth2/token`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  //       body: body.toString(),
  //     });

  //     const tokens = await res.json();
  //     console.log('[MS] Token response:', tokens);

  //     const idToken = tokens.id_token;
  //     if (!idToken) {
  //       console.error('[MS] No id_token:', tokens);
  //       ref.complete();
  //       this.router.navigate(['/auth/login']);
  //       return;
  //     }

  //     this.http
  //       .post(
  //         '/auth/microsoft-login',
  //         {},
  //         {
  //           headers: { Authorization: `Bearer ${idToken}` },
  //         },
  //       )
  //       .subscribe({
  //         next: (msRes: any) => {
  //           localStorage.setItem('access_token', msRes.AccessToken);

  //           this.http.get('/profiles', {}, { login: 'login' }).subscribe({
  //             next: (profile: any) => {
  //               this.userProfileService.setUserFeature(profile.role.modules);
  //               this.userProfileService.setUserProfile(profile);
  //               if (profile.language) {
  //                 localStorage.setItem('userLang', profile.language);
  //               }
  //               ref.complete();
  //               this.router.navigate(['/dashboard']);
  //             },
  //             error: (err) => {
  //               console.error('[MS] Get profile failed', err);
  //               ref.complete();
  //               this.router.navigate(['/auth/login']);
  //             },
  //           });
  //         },
  //         error: (err) => {
  //           console.error('[MS] microsoft-login API failed', err);
  //           ref.complete();
  //           this.router.navigate(['/auth/login']);
  //         },
  //       });
  //   } catch (err) {
  //     console.error('[MS] Exception:', err);
  //     ref.complete();
  //     this.router.navigate(['/auth/login']);
  //   }
  // }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
